import { Dialog } from "@dash/dialog";
import { Button } from "@dash/form";
import { useTheme } from "@emotion/react";
import React, { useState } from "react";
import { MdOutlinePerson } from "react-icons/md";
import { Link } from "react-router-dom-v5-compat";

import { CustomerDoc } from "@megaron/docs-contracts";

type Props = {
  customer: CustomerDoc;
  onDetach?: () => void;
};

export const CrmCustomerCard: React.FC<Props> = ({ customer, onDetach }) => {
  const theme = useTheme();
  const [isDetachDialogOpen, setIsDetachDialogOpen] = useState(false);

  return (
    <div
      css={{
        borderRadius: theme.smallBorderRadius,
        background: "white",
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
        border: `1px solid ${theme.colors.border}`,
      }}
    >
      <div
        css={{
          color: "white",
          background: theme.colors.primary,
          padding: "0.5rem 0.875rem",
          alignSelf: "stretch",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRight: `1px solid ${theme.colors.primary}`,
        }}
      >
        <MdOutlinePerson size={18} />
      </div>
      <div
        css={{
          minWidth: 0,
          padding: "0.5rem 0.75rem",
          display: "flex",
          flex: "1 0 0",
          flexDirection: "column",
        }}
      >
      <div css={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "0.5rem" }}>
        <div css={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
          <span css={{ fontSize: "0.75rem", color: theme.colors.secondaryText }}>Klient w CRM</span>
          <Link
            to={`/crm/customers/id/${customer.uuid}`}
            css={{ fontSize: "0.875rem", fontWeight: 700, color: theme.colors.primary }}
          >
            {customer.name}
          </Link>
        </div>
        <div css={{ display: "flex", alignItems: "center", gap: "0.75rem", flexShrink: 0 }}>
          <div css={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "2px" }}>
            {customer.phoneNumber?.trim() && (
              <a href={`tel:${customer.phoneNumber.replace(/\s/g, "")}`} css={{ fontSize: "0.75rem", color: theme.colors.primary }}>
                {customer.phoneNumber}
              </a>
            )}
            {customer.email && (
              <a href={`mailto:${customer.email}`} css={{ fontSize: "0.75rem", color: theme.colors.primary }}>
                {customer.email}
              </a>
            )}
          </div>
          {onDetach && (
            <button
              type="button"
              onClick={() => setIsDetachDialogOpen(true)}
              css={{ background: "none", border: "none", padding: "0 0.25rem", cursor: "pointer", fontSize: "16px", lineHeight: 1, color: theme.colors.secondaryText, "&:hover": { color: theme.colors.danger } }}
              title="Odepnij klienta"
            >
              ×
            </button>
          )}
        </div>
      </div>
      </div>
      {isDetachDialogOpen && (
        <Dialog header="Odpiąć klienta z CRM?" onClose={() => setIsDetachDialogOpen(false)} placement="center">
          <div css={{ display: "flex", width: "100%", gap: "0.5rem" }}>
            <Button css={{ width: "100%" }} variant="outline" onClick={() => setIsDetachDialogOpen(false)}>
              Nie
            </Button>
            <Button
              css={{ width: "100%" }}
              variant="primary"
              onClick={() => {
                onDetach?.();
                setIsDetachDialogOpen(false);
              }}
            >
              Tak
            </Button>
          </div>
        </Dialog>
      )}
    </div>
  );
};
